const actions = {
    async identidyInfoAction(context, params) {
        try {
            context.commit('identidyInfoMutation', params);
        } catch (error) {
            console.log(error);
        }
    },
};

export default actions;